module.exports = __webpack_public_path__ + "img/cdslogo.23397d4c.svg";